import React, { ComponentType, useEffect } from "react";
import { useSelector } from "react-redux";

import { getQuery } from "@redux/modules/value/search/search.selectors";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { AsideFlyout } from "@components/General/AsideFlyout/asideFlyout.component";
import { Button } from "@components/General/Button/button.component";

export type MobileFacetsProps = {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
};

type MobileFacetsComponent = { FacetsComponent: ComponentType<unknown> };

const MobileFacets = ({
    isOpen,
    onClose,
    className,
    FacetsComponent,
}: MobileFacetsProps & MobileFacetsComponent) => {
    const { t } = useGranite();

    const query = useSelector(getQuery);

    const close = () => {
        if (!isOpen) return;
        onClose();
    };

    useEffect(() => {
        close();
    }, [query]);

    const closeButton = (
        <Button
            type={"button"}
            color={"link"}
            className={"cursor-pointer"}
            onClick={close}
        >
            {t("search.refinements.mobile.close")}
        </Button>
    );

    return (
        <AsideFlyout
            open={isOpen}
            onClose={close}
            extraButtons={closeButton}
            closeButtonText={t("search.refinements.mobile.apply")}
            className={className}
        >
            <FacetsComponent />
        </AsideFlyout>
    );
};

export { MobileFacets };
